<template>
	<div 
			class="upload-container"
			:class="{ dragging: dragging }"
			ref="uploadContainer"
			@dragover.prevent
			@dragenter="handleDragEnter"
			@dragleave="handleDragLeave"
			@drop="handleFileDrop"
		>
		<form ref="uploadForm" @submit.prevent="submitForm">
			<input type="hidden" :name="csrfName" :value="csrfToken">
			<input
				type="file"
				ref="fileInput"
				name="files[]"
				accept="image/*,video/*"
				class="file-input"
				@change="handleManualInput"
			/>
			<div
				class="upload-icon"
				@drop="handleFileDrop"
				@click="triggerFileInput"
				v-if="!isUploading && !uploadDone && !filesDropped">
				<i class="material-symbols-outlined xlarge">upload</i>
				<p class="uk-padding" v-show="desktop">Klik op het icoon of sleep hier een bestand in om een video of foto te uploaden</p>
				<p class="uk-padding" v-show="!desktop">Klik op het icoon om een video of foto te uploaden</p>
				
			</div>
			<div @drop="handleFileDrop"
				class="uk-width-1-1 uk-padding uk-overflow-hidden" v-show="filesDropped && !isUploading && !uploadDone">
				<p>Bestand selecteerd: <br />{{ droppedFile }}</p>
				<textarea class="uk-textarea" name="description" ref="description" placeholder="Heb je nog informatie die relevant is, vul het hier in... Zo niet, klik op upload!"></textarea>
				<button class="uk-button uk-button-primary uk-margin-top" type="submit">Nee, start upload</button>
				<button class="uk-button uk-button-secondary uk-margin-top uk-margin-small-left" @click.prevent="resetForm">Annuleren</button>
			</div>
		</form>
		<div v-if="isUploading">
			<LoadingIndicator /><br />
			<p v-if="uploadPercentage">{{ uploadPercentage }}%</p>
		</div>
		<p v-if="uploadDone && !uploadError">
			<span class="material-symbols-outlined xlarge">task_alt</span><br />
			We hebben je inzending ontvangen en zullen er z.s.m. naar kijken.
		</p>
		<p v-if="uploadError" class="uk-alert uk-alert-danger" v-html="uploadError"></p>
	</div>
</template>

<script>
import axios from "axios"; // Assuming you're using axios for HTTP requests
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	components: { LoadingIndicator },
	props: {
		desktop: {
			type: Boolean,
			default: null
		}
	},
	data() {
		return {
			isUploading: false,
			uploadDone: false,
			uploadPercentage: null,
			uploadError: null,
			dragging: false,
			filesDropped: false,
			droppedFile: null
		};
	},
	computed: {
		csrfName () {
				return window.csrfTokenName
		},
		csrfToken () {
				return window.csrfTokenValue
		},
	},		
	methods: {
		triggerFileInput() {
			this.$refs.fileInput.click();
		},
		resetForm(event) {
			this.uploadDone = false;
			this.filesDropped = false;
			this.isUploading = false;
			this.uploadError = false;
		},
		submitForm(event) {
			
			var component = this;

			const files = component.$refs.fileInput.files;
			if (!files.length) {
				console.error('no files');
				return;
			}
				
			// Create formData object
			var formData = new FormData(event.target);
		
			// Append files
			for (let i = 0; i < files.length; i++) {
				formData.append("files[]", files[i]);
			}
			
			// Append description
			formData.append("description", component.$refs.description.value);
			
			// Add CSRF
			var data = {};			
			formData.append(data[component.csrfName], component.csrfToken);
			
			// Toggle indicator
			this.isUploading = true;
		
			// Do request
			axios({
				method: 'post',
				url: '/actions/_uploader/upload/upload',
				responseType: 'json',
				data: formData,
				headers: {
					"Content-Type": "multipart/form-data",
					"X-CSRF-Token": component.csrfToken
				},
				onUploadProgress: (progressEvent) => {
					this.uploadPercentage = Math.round(
						(progressEvent.loaded * 100) / progressEvent.total
					);
				}
			})
			.then(function (response) {
				component.isUploading = false;
				component.uploadDone = true;
				
				setTimeout(function() {
					component.resetForm();
				}, 4000);
			})
			.catch(function (error) {
	
				component.isUploading = false;			
				component.uploadDone = true;
				component.uploadError = error.response.data.name ?? '';
				
				if(error && error.response && error.response.data && error.response.data.message) {
					component.uploadError += '<br>' + error.response.data.message;
				}
			});
		},
		handleManualInput() {
			this.filesDropped = true;	
			let fileName = this.$refs.fileInput.files[0].name;
				if (fileName.length > 20) {
						this.droppedFile = fileName.slice(0, 14) + '...' + fileName.slice(-6);
				} else {
						this.droppedFile = fileName;
				}
		},
		handleDragEnter(event) {
			this.dragging = true;
		},
		handleDragLeave(event) {
			this.dragging = false;
		},
		handleFileDrop(event) {
			event.preventDefault();
			this.dragging = false;
			const files = event.dataTransfer.files;

			if (files.length) {
				this.filesDropped = true;			
				this.$refs.fileInput.files = files;
				//this.submitForm({ target: this.$refs.fileInput });
			}
		},		
	},
};
</script>

<style scoped>
.upload-container {
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: calc(100vh - 240px);
	border: 2px dashed #ccc;
	position: relative;
	transition: background-color 0.3s;
}
.file-input {
	display: none;
}
.upload-icon {
	font-size: 1.1rem;
	cursor: pointer;
}
.progress-circle {
	/* Add your circular progress indicator styles here */
}
.upload-container.dragging {
	background-color: #f0f0f0; 
}
</style>
